import createCustomContext from '../../../contexts/create-custom-context.js';

const [LegacyAutocompleteSelectedOptionsContextProvider, useLegacyAutocompleteSelectedOptionsContext] = createCustomContext('LegacyAutocompleteSelectedOptionsContext', {});

export { LegacyAutocompleteSelectedOptionsContextProvider, useLegacyAutocompleteSelectedOptionsContext };
